export default __webpack_public_path__ + "assets/images/40ca98f6ec0caa74695b5425d7362998.svg";